import React, { useEffect } from "react";
import { SectionUnlockingSwitch } from "features/AdminPanel/modules/SectionUnlockingSwitch/SectionUnlockingSwitch";
import { useAdminPanelStore } from "features/AdminPanel/store/useAdminPanelStore";
import { useWalletStore } from "features/Account/modules/Wallets/store/WalletStore";
import { automatedPayoutKeys } from "features/Account/modules/Wallets/constants/Wallets.constants";
import { useWalletSettings } from "../../utils/useWalletSettings";

export const PayoutAutomationToggle = ({ subSectionKey }) => {
  const sectionConfig = useAdminPanelStore((state) => state.sectionConfig);
  const subSectionConfig = sectionConfig[subSectionKey] || {};
  const { value } = subSectionConfig;
  const automatedPayoutToggle = useWalletStore(
    (state) => state.automatedPayoutToggle
  );
  const isAutomatedPayoutToggle = useWalletStore(
    (state) => state.isAutomatedPayoutToggle
  );
  const isAutomatedPayoutModalOpen = useWalletStore(
    (state) => state.isAutomatedPayoutModalOpen
  );

  const { updateAutomatatedPayoutSettings } = useWalletSettings();

  const handleToggleChange = () => {
    isAutomatedPayoutToggle(!automatedPayoutToggle);
    if (!automatedPayoutToggle) {
      isAutomatedPayoutModalOpen(true);
    } else {
      updateAutomatatedPayoutSettings({ isAutomated: !automatedPayoutToggle });
    }
  };

  useEffect(() => {
    isAutomatedPayoutToggle(!!value?.[automatedPayoutKeys.isAutomated]);
  }, []);

  return (
    <div className="tw-flex tw-items-center">
      <SectionUnlockingSwitch
        value={automatedPayoutToggle}
        onChange={handleToggleChange}
      />
    </div>
  );
};
